// Google Drive görsel linkini gömülebilir (lh3) biçime çevirir.
// Backend genelde "https://lh3.googleusercontent.com/d/<id>" verir; farklı
// Drive biçimleri gelirse id çıkarılıp normalize edilir.
export function driveImageUrl(url?: string, width = 1200): string | undefined {
  if (!url) return undefined;
  // Zaten lh3 ise olduğu gibi (gerekirse boyut ekle).
  if (url.includes('lh3.googleusercontent.com')) {
    return url.includes('=w') ? url : `${url}=w${width}`;
  }
  // Çeşitli Drive linklerinden dosya id'sini çıkar.
  const m =
    url.match(/\/d\/([a-zA-Z0-9_-]+)/) ||
    url.match(/[?&]id=([a-zA-Z0-9_-]+)/) ||
    url.match(/\/file\/d\/([a-zA-Z0-9_-]+)/);
  const id = m?.[1];
  if (id) return `https://lh3.googleusercontent.com/d/${id}=w${width}`;
  return url;
}
